import { cn } from "@/shared/utils";
import { Button } from "./button";
import { Icon } from "./icon";
import { Input } from "./input";

type SearchInputProps = {
    search: string;
    setSearch: (search: string) => void;
    placeholder?: string;
    className?: string;
};

export function SearchInput({ search, setSearch, placeholder, className }: SearchInputProps) {
    return (
        <div className={cn("grid grid-cols-[1fr_auto] items-center", className)}>
            <Input
                placeholder={placeholder ?? "Zoeken"}
                className="placeholder:text-content-subtle col-span-2 col-start-1 row-start-1 pl-11"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                data-testid="search-input"
                title={search ? "" : placeholder}
            />
            <Icon name="search" className="col-start-1 row-start-1 pl-3" />
            {search && (
                <div className="col-start-2 row-start-1 pr-2">
                    <Button
                        iconOnly
                        icon="close"
                        className="text-content-subtle"
                        variant="tertiary"
                        title="Wissen"
                        onClick={() => setSearch("")}
                    />
                </div>
            )}
        </div>
    );
}
